import React, { useState, useEffect } from 'react';
import { ModalCenterFont, ContentContainer3, ContentContainerTable, SelectContainer, InputContainer } from './styles';
import FailIcon from './../../../assets/fail_icon.png'
import { horarioPadraoLabelFactory, horaParaMinutos, verificaConflitosDeHorarios } from '../../../utils';
import TrashIcon from './../../../assets/trash2_icon.png';
import AddIcon from './../../../assets/plus_icon.png'

function ModalFormAddWorkingHours(props) {
    const dias = [
        { label: 'Seg à Sex', value: 'Seg à Sex' },
        { label: 'Seg a Sáb', value: 'Seg a Sáb' },
        { label: 'Seg a Dom', value: 'Seg a Dom' },
        { label: 'Sábado', value: 'Sábado' },
        { label: 'Domingo', value: 'Domingo' },
        { label: 'Final de Semana', value: 'Final de Semana' },
      ];
    const [horarios, setHorarios] = useState([]);
    const [diasSemana, setDiasSemana] = useState(dias[0].value);
    const [horaInicio, setHoraInicio] = useState();
    const [horaFim, setHoraFim] = useState();
    const [erroMsg, setErroMsg] = useState(false);
    const modalStyle = {
        maxWidth: 'fit-content'
    }

    useEffect(() => {
        setDiasSemana(dias[0].value);
        setHoraInicio('');
        setHoraFim('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.appear])

    useEffect(() => {
        if (props.horarioPadraoAtendimento) {
            setHorarios(props.horarioPadraoAtendimento?.value)
            setErroMsg(false)
        }
    }, [props.horarioPadraoAtendimento])

    return (
        <>
            <ModalCenterFont appear={props.appear}>
                <div className="br-modal is-medium" style={modalStyle} id="modal">
                    <div className="br-card">
                        <div className="container-fluid p-4">
                            <div className="br-modal-header">
                                <div className="br-modal-title">
                                    <strong style={{color: '#0c326f'}}>Novo horário padrão de atendimento</strong>
                                </div>
                            </div>
 
                            <div className="br-modal-body">
                            <ContentContainer3>
                                <ContentContainerTable>
                                {erroMsg && <span className="feedback danger" role="alert" >
                                                                    <i className="fas fa-times-circle" aria-hidden="true">
                                                                        <img
                                                                            src={FailIcon}
                                                                            style={{ paddingBottom: '5px' }}
                                                                            alt="failicon"
                                                                        />
                                                                    </i>
                                                                    {erroMsg}
                                                                </span>}
                                    <div className='br-table' data-selection='data-selection'>
                                    <table>
                                        <thead>
                                        <tr>
                                            <th scope='col0' style={{ color: '#1351B4' }}></th>

                                            <th scope='col3' style={{ color: '#1351B4' }}>
                                                Dias da semana
                                            </th>
                                            <th scope='col3' style={{ color: '#1351B4' }}>
                                                Horário Inicial
                                            </th>
                                            <th scope='col4' style={{ color: '#1351B4' }}>
                                                Horário Final
                                            </th>
                                            <th scope='col4' style={{ color: '#1351B4' }}>
                                                Ação
                                            </th>

                                            <th scope='col99' style={{ color: '#1351B4' }}></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            {horarios?.map((h) => (
                                                <tr>
                                                    <td> </td>
                                                    <td>{h.DIAS_SEMANA}</td>
                                                    <td>{h.HORA_INICIO}</td>
                                                    <td>{h.HORA_FIM}</td>
                                                    <td>
                                                        <img
                                                            src={TrashIcon}
                                                            alt="trashIcon"
                                                            title="Remover"
                                                            style={{
                                                                'marginRight': '10px',
                                                                'cursor': 'pointer'
                                                            }}
                                                            onClick={() => {
                                                                setHorarios(horarios?.filter(i => i.DIAS_SEMANA !== h.DIAS_SEMANA))
                                                            }}
                                                        />
                                                    </td>
                                                    <td> </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td> </td>

                                                <td>
                                                <SelectContainer>
                                                    <select
                                                        value={diasSemana}
                                                        onChange={(e) => {
                                                            setDiasSemana(e.target.value)
                                                            setErroMsg(false)
                                                        } }
                                                        style={{'borderRadius':'6px', 'width':'200px'}}
                                                        >
                                                        {dias.map((d) => (
                                                        <option key={d.value} value={d.value}>
                                                            {d.label}
                                                        </option>
                                                        ))}
                                                    </select>
                                                </SelectContainer>
                                                </td>
                                                <td>
                                                <InputContainer>
                                                <input
                                                    style={{borderRadius:'6px',textAlign: 'center', fontFamily: 'inherit', fontSize: '100%', fontWeight: 'var(--font-weight-medium)', color: 'var(--color-secondary-07)', border: '1px solid #888', height: 'var(--input-size)'}}
                                                    type='time'
                                                    value={horaInicio}
                                                    onChange={(e) => {setHoraInicio(e.target.value); setErroMsg(false)} }
                                                />
                                                </InputContainer>
                                                </td>
                                                <td>
                                                <InputContainer>
                                                <input
                                                    style={{borderRadius:'6px',textAlign: 'center', fontFamily: 'inherit', fontSize: '100%', fontWeight: 'var(--font-weight-medium)', color: 'var(--color-secondary-07)', border: '1px solid #888', height: 'var(--input-size)'}}
                                                    type='time'
                                                    value={horaFim}
                                                    onChange={(e) => {setHoraFim(e.target.value); setErroMsg(false)}}
                                                />
                                                </InputContainer>
                                                </td>
                                                <td>
                                                    <img
                                                        src={AddIcon}
                                                        alt="AddIcon"
                                                        title="Incluir"
                                                        style={{
                                                            'marginRight': '10px',
                                                            'cursor': 'pointer'
                                                        }}
                                                        onClick={() => {
                                                            if (!horaInicio) {
                                                                setErroMsg("Preencha o campo Horário Inicial")
                                                                return;
                                                            } 
                                                            if (!horaFim) {
                                                                setErroMsg("Preencha o campo Horário Final")
                                                                return;
                                                            } 
                                                            if (horaInicio === horaFim) {
                                                                setErroMsg("O horário inicial não pode ser igual ao horário final");
                                                                return;
                                                            }
                                                            if (horaParaMinutos(horaInicio) > horaParaMinutos(horaFim)) {
                                                                setErroMsg("O horário inicial não pode ser maior do que o horário final");
                                                                return;
                                                            }

                                                            const existe = horarios.some(h => h.DIAS_SEMANA === diasSemana);
                                                            if (existe) {
                                                                setErroMsg("Dia da semana já incluído.")
                                                                return;
                                                            }

                                                            //Verifica se há algum horário conflitante
                                                            const erroMsg = verificaConflitosDeHorarios(horarios, {DIAS_SEMANA: diasSemana, HORA_INICIO: horaInicio, HORA_FIM: horaFim});
                                                            if (erroMsg) {
                                                                setErroMsg(erroMsg);
                                                                return;
                                                            }

                                                            setHorarios([...horarios, {DIAS_SEMANA: diasSemana, HORA_INICIO: horaInicio, HORA_FIM: horaFim}])

                                                            setDiasSemana(dias[0].value);
                                                            setHoraInicio('');
                                                            setHoraFim('');
                                                        }}
                                                    />
                                                </td>
                                                <td> </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                </ContentContainerTable>
                                </ContentContainer3>
                            </div>

                            <div className="br-modal-footer justify-content-end">
                                <>
                                    <button className="br-button secondary small m-2" type="button" onClick={()=>{props.setModalAdicionarNovoHorarioVisible(false); setErroMsg(false);}}>
                                        {props.textButton1}
                                    </button>

                                        <button className="br-button primary small m-2" type="submit" onClick={() => {
                                            if (horarios?.length === 0) {
                                                setErroMsg('Preencha o campos e clique no botão "+".')
                                                return;
                                            }

                                            let horarioPadraoLabel = horarioPadraoLabelFactory(horarios)
                                            
                                            if (!props.workingHoursOptions.some( i => (i.label === horarioPadraoLabel.label))) {
                                                let workingHoursOptions = props.workingHoursOptions;
                                                workingHoursOptions.push(horarioPadraoLabel)
                                                props.setWorkingHoursOptions(workingHoursOptions)
                                            }                                            
                                            props.setDefaultFormValues({ ...props.defaultFormValues, horarios: horarios }); 
                                            props.setShowErroAgencyWorkingHours(false); //Limpa erro
                                            props.setHorarioPadraoAtendimento(horarioPadraoLabel)
                                            props.setModalAdicionarNovoHorarioVisible(false)
                                        }}>
                                            {props.textButton2}
                                        </button>

                                </>                                
                            </div>
                        </div>
                    </div>
                </div>
            </ModalCenterFont>

        </>
    );
}

export default ModalFormAddWorkingHours;